import actionsMessageFr from '../actions/fr-FR';

export default {
  actions: {
    ...actionsMessageFr,
    noItems: "Ce plan d'actions ne contient pas encore d'actions",
  },
  icon: 'playlist_add_check',
  name: "Plan d'actions",
  title: "Plans d'actions",
  multi_property: 'Multi-installations',
  noItems:
    "Il n'y a pas encore de plan d'actions en relation avec l'organisation et les filtres sélectionnés",
  fields: {
    properties: 'Installations',
    author_id: 'Auteur',
    day_s: '{n} jour | {n} jour | {n} jours',
    property_search_name_list: 'Installations',
    action_plan_origins: 'Origines',
    node_id: 'Plan mono installation',
    action_plan_type: 'Type',
    action_plan_status: 'Etat',
    property_search_code_list: 'Code',
    property_search_shortname_list: 'Nom court',
    description: 'Diagnostic',
    origins: 'Origines',
    entity_id: 'Equipe',
    creation_datetime: 'Date de création',
    gain_mwh: 'Gain',
    total_gain: 'Total des gains',
    id: 'ID',
    start_datetime: 'Date de début',
    end_datetime: 'Date de cloture',
    code: 'Code installation',
    shortname: 'Nom court',
    on_site: 'Sur site',
    node_associated_code: 'Code installation',
    node_associated_name: 'Nom',
    node_associated_shortname: 'Nom court',
    node_associated_nav_full_id: 'Nav_full_id',
    type_name: 'Type',
    author_name: 'Auteur',
    number_of_actions_associeted: "Nombre d'actions",
    author: {
      name: 'Auteur',
    },
    current_action_plan_status_datetime: 'Date de modification',
    current_act_status_type_name: 'Etat',
  },
  create: {
    validate: "Créer le plan d'action",
    icon: 'playlist_add',
    title: "Créer un plan d'actions",
    btnText: "Créer un plan d'actions",
    origin: 'Origine',
    origins: {
      add: 'Ajouter une origine',
      remove: "Supprimer l'origine",
    },
    noorigin: 'Origine requise',
    noproperty: 'Installation requise',
    description: 'Diagnostic',
    type: 'Type',
    action_plan_status: 'Etat',
    notype: 'Type requis',
    entity: 'Organisation',
    properties: 'Installations',
  },
  update: {
    validate: 'Mettre à jour',
    title: "Modifier le plan d'actions",
    icon: 'edit',
    btnText: '',
    origin: 'Origine',
    description: 'Diagnostic',
    type: 'Type',
    entity: 'Equipe',
    properties: 'Installations',
  },
  delete: {
    validate: "Supprimer ce plan d'action ?",
    title: "Supprimer le plan d'actions",
    icon: 'delete',
  },
  item: {
    noItems: "Plan d'actions introuvable",
    link: "Lien vers le plan d'actions",
  },
  list_action_not_ended: {
    title: 'Les actions qui ne sont pas terminées',
    text:
      'Les actions ci-dessous ne sont pas terminées, si vous appuyez sur le bouton modifier, alors toutes ces actions seront annulées.',
    cancel_btn: 'retour',
    submit_btn: 'modifier',
  },
};
